"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const translationContext_1 = require("configs/translationContext");
const useModal_1 = require("hooks/useModal");
const mobx_react_1 = require("mobx-react");
const services_1 = require("modules/app/services");
const dripping_1 = require("modules/app/services/datahub/dripping");
const useDatahubBaseEvent_1 = __importDefault(require("modules/app/services/datahub/useDatahubBaseEvent"));
const dripping_2 = require("modules/app/services/datahubEvents/dripping");
const ModuleEditorParamsUtils_1 = __importDefault(require("modules/content/moduleEditor/ModuleEditorParamsUtils"));
const createNewDripping_1 = __importDefault(require("./createNewDripping"));
const drippingForm_1 = __importDefault(require("./drippingForm"));
const drippingList_1 = __importDefault(require("./drippingList"));
const constants_1 = require("../constants");
const useSetClassesForDripping_1 = __importDefault(require("../hooks/useSetClassesForDripping"));
const stores_1 = require("../stores");
const mapStateToProps = (stores) => ({
    drippings: stores.DrippingStore.items
});
const handleLearnMoreClick = () => {
    services_1.DatahubEventsService.sendEvent({
        schema: new dripping_2.ViewDrippingLearnMore({
            arrivedFrom: services_1.ArrivedFrom.DRIPPING_LEARN_MORE
        })
    });
};
const DrippingSection = ({ drippings, pageType }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const drippingSidebar = (0, useModal_1.useModal)();
    const { moduleId } = (0, react_router_dom_1.useParams)();
    const [selectedDripping, setSelectedDripping] = (0, react_1.useState)(null);
    const baseEvent = (0, useDatahubBaseEvent_1.default)();
    const { params: { id, pageId } } = (0, react_router_dom_1.useRouteMatch)();
    const contentId = id || pageId || '';
    (0, useSetClassesForDripping_1.default)({ isBulkOperation: false });
    (0, react_1.useEffect)(() => {
        return () => stores_1.DrippingStore.clear();
    }, []);
    (0, react_1.useEffect)(() => {
        stores_1.DrippingStore.setPageType(pageType);
    }, [pageType]);
    (0, react_1.useEffect)(() => {
        stores_1.DrippingStore.setImpactedModuleId(moduleId);
    }, [moduleId]);
    const handleClick = () => {
        drippingSidebar.handleOpen();
    };
    const handleEdit = (drippingKey) => {
        const dripping = drippings.find((item) => item.key === drippingKey);
        setSelectedDripping(dripping || null);
        if (dripping) {
            drippingSidebar.handleOpen();
        }
    };
    const handleRemove = (drippingKey) => {
        stores_1.DrippingStore.deleteItem(drippingKey);
        dripping_1.DatahubDrippingService.sendRemoveEvent({
            ...baseEvent,
            contentType: pageType,
            contentId,
            isExtraModule: ModuleEditorParamsUtils_1.default.getExtraParam()
        });
    };
    const handleCloseSidebar = () => {
        setSelectedDripping(null);
        drippingSidebar.handleClose();
    };
    const handleDrippingClose = (drippingAborted) => {
        handleCloseSidebar();
        const drippingCancelEvent = {
            ...baseEvent,
            contentType: pageType,
            contentId,
            isExtraModule: ModuleEditorParamsUtils_1.default.getExtraParam(),
            isAllClasses: drippingAborted.allClasses,
            ...(drippingAborted.releaseDays && {
                liberationDays: drippingAborted.releaseDays
            }),
            ...(drippingAborted.releaseDate && {
                liberationDate: drippingAborted.releaseDate
            }),
            ...(drippingAborted.pageId && {
                pageId: drippingAborted.pageId
            }),
            ...(drippingAborted.expirationDays && {
                expirationDays: drippingAborted.expirationDays
            })
        };
        if (drippingAborted.id) {
            dripping_1.DatahubDrippingService.sendCancelEditEvent(drippingCancelEvent);
        }
        else {
            dripping_1.DatahubDrippingService.sendCancelNewEvent(drippingCancelEvent);
        }
    };
    const handleDrippingSave = (dripping) => {
        const currentIndex = drippings.findIndex((item) => item.key === dripping.key);
        if (currentIndex > -1) {
            drippings[currentIndex] = dripping;
            stores_1.DrippingStore.setItems([...drippings]);
        }
        else {
            stores_1.DrippingStore.setItems([...drippings, { ...dripping }]);
        }
        stores_1.DrippingStore.openDrippingCard(dripping.key);
        handleCloseSidebar();
        dripping_1.DatahubDrippingService.sendNewEvent({
            ...baseEvent,
            contentType: pageType,
            contentId,
            isExtraModule: ModuleEditorParamsUtils_1.default.getExtraParam(),
            isAllClasses: dripping.allClasses,
            ...(dripping.releaseDays && { liberationDays: dripping.releaseDays }),
            ...(dripping.releaseDate && { liberationDate: dripping.releaseDate }),
            ...(dripping.pageId && { pageId: dripping.pageId }),
            ...(dripping.expirationDays && {
                expirationDays: dripping.expirationDays
            })
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "_p-5 _rounded _border _border-gray-200", children: [(0, jsx_runtime_1.jsxs)("section", { className: (0, classnames_1.default)('_d-flex _flex-column _flex-sm-row _justify-content-between _align-items-start _gap-4', { '_mb-5': drippings.length > 0 }), children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { className: "_text-5 _font-weight-bold _mb-2", children: t('dripping_2.title') }), (0, jsx_runtime_1.jsxs)("small", { className: "_text-2 _text-gray-500 _mt-4", children: [t('dripping_2.description_v2'), (0, jsx_runtime_1.jsxs)("a", { href: constants_1.DRIPPING_LEARN_MORE_LINK, onClick: handleLearnMoreClick, rel: "noreferrer noopener", target: "_blank", className: "_d-inline-flex _align-items-center _gap-1 _text-blue-dark _ml-2", children: [t('general.know_more'), (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'external-link'], size: "sm" })] })] })] }), (0, jsx_runtime_1.jsx)(createNewDripping_1.default, { onClick: handleClick })] }), (0, jsx_runtime_1.jsx)(drippingList_1.default, { drippings: drippings, onEditClick: handleEdit, onRemoveClick: handleRemove })] }), drippingSidebar.isModalOpen && ((0, jsx_runtime_1.jsx)(drippingForm_1.default, { dripping: selectedDripping, onClose: handleDrippingClose, onSave: handleDrippingSave }))] }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingSection);
